import React from 'react'
import Layout from '../../Layout'
import ResturantCategoryListContainer from '../../../../Components/Category/ResturantCategoryListContainer/ResturantCategoryListContainer'

const ResturantCategoryList = () => {
  return (
    <Layout><ResturantCategoryListContainer/></Layout>
  )
}

export default ResturantCategoryList